import React from 'react';
import {
  Backdrop,
  CircularProgress,
  Typography,
  Box,
} from '@mui/material';
import { useAlbum } from '../../contexts/AlbumContext';

const LoadingOverlay = () => {
  const { loading } = useAlbum();

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: 'column',
        gap: 2,
      }}
      open={loading}
    >
      <CircularProgress color="inherit" size={48} />
      <Box
        sx={{
          bgcolor: 'rgba(0, 0, 0, 0.6)',
          borderRadius: 2,
          px: 3,
          py: 1.5,
        }}
      >
        <Typography variant="body1" color="inherit">
          처리 중...
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default LoadingOverlay;
